import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import { GetNewGuid } from "../../helpers/GuidHelper";
import Interaction, { InteractionType } from "./Interaction";
import ParallelSequenceNodePreview from "../../features/sequence/node_previews/ParallelSequenceNodePreview";

export interface IParallelSequence extends Interaction {
  finishAll: boolean;
  blockOthers: boolean;
  abortOthersOnFinish: boolean;
}

export const parallelSequenceInteraction = (): InteractionFactoryEntity => {
  const create = (getKeys: (amount: number) => string[]): IParallelSequence => {
    return {
      id: GetNewGuid(),
      name: "Parallel Sequence",
      type: InteractionType.ParallelSequence,
      finishAll: true,
      blockOthers: false,
      abortOthersOnFinish: false,
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction,
  ): IParallelSequence => {
    const prev = interaction as IParallelSequence;
    return {
      ...prev,
      finishAll: prev.finishAll ?? true,
      blockOthers: prev.blockOthers ?? false,
      abortOthersOnFinish: prev.abortOthersOnFinish ?? false,
    };
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
  ): IParallelSequence => {
    const source = interaction as IParallelSequence;
    return {
      id: GetNewGuid(),
      name: "Parallel Sequence",
      type: InteractionType.ParallelSequence,
      finishAll: source.finishAll ?? true,
      blockOthers: source.blockOthers ?? false,
      abortOthersOnFinish: source.abortOthersOnFinish ?? false,
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string,
  ): string[] => {
    return [];
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string,
    ) => SearchResultData[],
  ): SearchResultData[] => {
    return getMatchingResults(
      [interaction.name],
      takeName,
      interaction,
      "ParallelSequence",
    );
  };

  const validateErrors = (interaction: Interaction): string[] => {
    return [];
  };

  return {
    View: <div>Parallel Sequence</div>,
    Create: create,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <ParallelSequenceNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    FilterType: "ParallelSequence",
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
  };
};
